module.exports = "<div class=\"grid-header-view\"></div>\r\n<div class=\"grid-content-view\"></div>\r\n<div class=\"js-nocolumns-view-region\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/grid.hbs
// module id = 706
// module chunks = 0